// The model's 46 inventory markers plus silence and breath. Pronunciations and dictionary availability must not change which tokens the app accepts.
export const PHONEME_INVENTORY: ReadonlySet<string> = new Set([
  "aa",
  "ae",
  "ah",
  "ao",
  "aw",
  "ax",
  "ay",
  "b",
  "ch",
  "cl",
  "d",
  "dh",
  "dr",
  "dx",
  "eh",
  "er",
  "ey",
  "f",
  "g",
  "hh",
  "ih",
  "iy",
  "jh",
  "k",
  "l",
  "m",
  "n",
  "ng",
  "ow",
  "oy",
  "p",
  "q",
  "r",
  "s",
  "sh",
  "t",
  "th",
  "tr",
  "uh",
  "uw",
  "v",
  "vf",
  "w",
  "y",
  "z",
  "zh",
  "sp",
  "ap",
]);
